import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-dark py-10 md:py-12 px-4 md:px-6" data-id="element-107">
      <div className="max-w-4xl mx-auto text-center" data-id="element-108">
        <h3 className="text-xl md:text-2xl font-display font-bold text-gold-accent mb-2 md:mb-3" data-id="element-109">
          FUTBOL GOTOWY: SYSTEM 365
        </h3>
        <p className="text-sm md:text-base text-gray-300 mb-6 md:mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-110">
          Najlepszy sposób na trenowanie piłki nożnej bez przygotowywania
          wszystkiego od zera
          <br className="hidden sm:block" data-id="element-111" />
          Praktyczne narzędzia dla trenerów którzy chcą konkretnych wyników
        </p>
        <div className="border-t border-gold-accent/20 pt-6 md:pt-8" data-id="element-112">
          <p className="text-xs md:text-sm text-gray-400 mb-1 md:mb-2" data-id="element-113">
            © 2026 — Wszelkie prawa zastrzeżone
          </p>
          <p className="text-xs md:text-sm text-gray-500" data-id="element-114">
            Produkt cyfrowy — PDF do natychmiastowego pobrania
          </p>
        </div>
      </div>
    </footer>;
}